import { useCallback, useEffect, useState } from 'react'
import { useSelector, useStore } from 'react-redux'
import { get, isNil } from 'lodash'

import { showErrorNotification } from '../../common/helpers'
import { apolloService, httpService } from '../../common/services'

import { useRefreshTokenMutation } from '../../account/hooks'

const Bootstrap = ({ children }) => {
  const [isMounting, setIsMounting] = useState(true)
  const store = useStore()

  const { accessToken, refreshToken } = useSelector(
    store => store?.account?.user,
  )

  const [refreshAccessToken, { isLoading: isRefreshingToken, error }] =
    useRefreshTokenMutation()

  const getAccessToken = useCallback(
    () => get(store.getState(), 'account.user.accessToken'),
    [store],
  )

  const getNewAccessToken = useCallback(
    () => refreshAccessToken(refreshToken),
    [refreshAccessToken, refreshToken],
  )

  useEffect(() => {
    const initialize = async () => {
      await apolloService.client.addPossibleTypesToCache()
      setIsMounting(false)
    }

    if (isMounting) {
      initialize()
    }
  }, [isMounting])

  useEffect(() => {
    if (!isNil(accessToken)) {
      apolloService.client.addAccessTokenToHeaders(
        getAccessToken,
        getNewAccessToken,
      )

      httpService.addAccessTokenToHeaders(getAccessToken, getNewAccessToken)
    } else {
      apolloService.client.removeAccessTokenFromHeaders()
    }
  }, [
    accessToken,
    getAccessToken,
    getNewAccessToken,
    refreshAccessToken,
    refreshToken,
  ])

  useEffect(() => {
    if (error) {
      showErrorNotification({
        title: 'User error',
        description: error,
      })
    }
  }, [error])

  if (isMounting || isRefreshingToken) return null

  return children
}

export default Bootstrap
